import React from "react";
import PropTypes from "prop-types";
import "./detailedTerms.scss";


const DetailedTerms = () => {
    const data = [
        {
            id: 1, title: 'Đối tượng và phạm vi hợp đồng',
            text:
                <>
                    <div>Điều khoản dịch vụ này được áp dụng cho tất cả các vấn đề liên quan đến việc đăng ký, sử dụng Dịch vụ APIs Map4D giữa bên sử dụng dịch vụ và bên cung cấp dịch vụ. </div>

                </>
        },

        {
            id: 3, title: 'Quyền và nghĩa vụ của các bên ',
            text:
                <>
                    <div className="titContent">Quyền và nghĩa vụ của IOTLink</div>
                    <div>Đảm bảo hệ thống kỹ thuật và đường truyền hoạt động ổn định 24/7 để đáp ứng đúng các yêu 
                        cầu về Dịch vụ của Khách hàng; hỗ trợ Khách hàng trong việc kết nối, chạy thử, nghiệm thu và sử dụng Dịch vụ.</div>

                    <div>Vào bất kỳ lúc nào mà không cần thông báo trước cho Khách hàng, IOTLink có thể tiến hành các điều chỉnh về Dịch vụ cần thiết để đảm bảo tuân thủ các điều kiện về an toàn được áp dụng hay các yêu cầu pháp luật khác, miễn rằng những điều chỉnh này không ảnh hưởng đến tính chất hay chất lượng của Dịch vụ, không ảnh hưởng đến tiến độ và thời hạn thực hiện Hợp đồng. </div>

                    <div>Bảo mật thông tin dữ liệu được chuyển trực tiếp từ Khách hàng sang IOTLink. </div>

                    <div>IOTLink có nghĩa vụ xuất hóa đơn giá trị gia tăng hợp lệ cho Khách hàng. </div>

                    <div>IOTLink được quyền yêu cầu Khách hàng cung cấp những văn bản chứng minh và cam kết về nội dung/bản quyền nội dung trong trường hợp cần thiết. </div>

                    <div>IOTLink được miễn trừ mọi trách nhiệm liên quan đến việc tranh chấp giữa Khách hàng và bên thứ ba về quyền sở hữu và bản quyền đối với các nội dung mà Khách hàng cung cấp cho IOTLink, trừ trường hợp IOTLink tự ý chỉnh sửa đối với các nội dung đó mà không được sự đồng ý bằng văn bản của Khách hàng. </div>

                    <div>Được quyền yêu cầu Khách hàng thực hiện xác nhận đối soát và thanh toán phí Dịch Vụ hàng tháng theo đúng thời hạn đã được quy định. </div>

                    <div>IOTLink có quyền tạm ngừng cung cấp Dịch vụ cho một hoặc các trường hợp sau: Khẩn cấp theo yêu cầu của Cơ quan nhà nước có thẩm quyền. và/hoặc IOTLink phát hiện Khách hàng có vi phạm các điều khoản sử dụng và/hoặc Khách hàng không khắc phục các vi phạm này trong thời hạn mà IOTLink quy định và/hoặc Khách hàng không thanh toán đúng hạn: phí sử dụng dịch vụ, tiền phạt vi phạm, tiền bồi thường thiệt hại (nếu có). Trong trường hợp này, IOTLink sẽ gửi thông báo trước cho Khách hàng 05 (năm) ngày làm việc trước khi tạm ngừng Dịch vụ. </div>

                    <div>Thời gian uptime hàng tháng của hệ thống luôn sẵn sàng tối thiểu ở mức 99,9% trong suốt một chu kỳ thanh toán theo cam kết dịch vụ. </div>

                    <div>Bản đồ được tích hợp đúng quy định pháp luật Việt Nam, hình ảnh bản đồ khi được tải về phải đảm bảo thể hiện đầy đủ chủ quyền lãnh thổ, biên giới quốc gia. Đối với địa giới hành chính, IOTLink sẽ cập nhật nếu có thay đổi theo quy định của cơ quan thẩm quyền.</div>

                    <div>Đảm bảo thời gian thực hiện Dịch vụ và số lần đáp ứng cho các yêu cầu của IOTLink đúng theo thỏa thuận. </div>

                    <div>Hình ảnh tải về theo chất lượng dữ liệu Khách Hàng cập nhật. </div>

                    <div>Phản hồi cho Khách hàng nhanh nhất có thể khi có yêu cầu và không quá 48h làm việc. </div>

                    <div>Được phép sử dụng logo của Khách hàng (nếu là Khách hàng Doanh nghiệp) để quảng bá, truyền thông trên các phương tiện truyền thông, ấn phẩm về Khách hàng đã sử dụng Dịch vụ của IOTLink. </div>

                </>
        },
        {
            id: 4, title: 'Quyền và nghĩa vụ của Khách hàng ',
            text:
                <>
                    <div>Tự đầu tư hệ thống kỹ thuật và đường truyền để kết nối với IOTLink. </div>

                    <div>Chịu trách nhiệm về các nội dung cung cấp trên hệ thống của IOTLink. Khách hàng cam kết, đảm bảo với IOTLink rằng nội dung Khách hàng cung cấp cho IOTLink là: </div>

                    <div>(a) Nội dung thuộc quyền sở hữu của Khách hàng, và/hoặc có bản quyền hợp pháp. </div>

                    <div>(b) Nội dung phù hợp với quy định của pháp luật Việt Nam và các Công ước quốc tế mà Việt Nam là thành viên. </div>

                    <div>(c) Nội dung không xâm phạm và không ảnh hưởng đến quyền sở hữu trí tuệ và các quyền hợp pháp của bất kỳ tổ chức hoặc cá nhân nào. </div>

                    <div>Trong trường hợp nội dung Khách hàng cung cấp cho IOTLink bị tranh chấp, khiếu kiện vi phạm quyền tác giả, hoặc/và quyền liên quan đến quyền tác giả hoặc/và các quyền hợp pháp khác bởi bất kỳ bên thứ ba nào thì Khách hàng phải hoàn toàn chịu trách nhiệm giải quyết và chịu mọi chi phí, thiệt hại hay bất kỳ khoản tiền nào phát sinh từ việc tranh chấp, khiếu kiện nêu trên. Trong trường hợp xảy ra tranh chấp đối với các nội dung mà IOTLink tự ý chỉnh sửa đối với các nội dung do Khách hàng cung cấp mà không được sự đồng ý bằng văn bản của Khách hàng thì IOTLink phải chịu trách nhiệm bồi thường liên quan đến các nội dung đó. </div>

                    <div>Khách hàng có trách nhiệm giải quyết mọi khiếu nại và thắc mắc liên quan tới đối tác và khách hàng của Khách Hàng (nếu có). </div>

                    <div>Thực hiện việc đối soát và thanh toán theo đúng quy định tại điều khoản này. </div>

                    <div>Được miễn trừ mọi trách nhiệm liên quan tới các tranh chấp, khiếu nại, khiếu kiện giữa IOTLink và bên thứ ba về bản quyền của công nghệ và Dịch vụ mà IOTLink cung cấp cho Khách hàng (nếu có). </div>

                    <div>Phản ánh một cách trung thực về Dịch vụ của IOTLink (nếu có) và mọi phản ánh đều phải có bằng chứng xác thực kèm theo dù phản ánh qua bất kỳ hình thức, phương thức giao tiếp nào
                        với đảm bảo rằng không một nhân viên nào hoặc bất cứ ai thuộc sự quản lý của Khách hàng vi phạm điều này. </div>

                    <div>Khách hàng có nghĩa vụ thực hiện đúng và đầy đủ các nghĩa vụ theo quy định tại chính sách, phụ lục sử dụng dịch vụ,
                        bồi thường thiệt hại cho IOTLink trong trường hợp vi phạm nghĩa vụ theo quy định. Mức bồi thường sẽ được hai bên thỏa thuận.</div>

                    <div>Khách hàng có nghĩa vụ thanh toán cước phí đã sử dụng cho IOTLink đến thời điểm Khách hàng ngừng sử dụng dịch vụ của IOTLink.</div>

                    <div>Không được chuyển nhượng, trao đổi, phân phối hay bán Dịch vụ của IOTLink cho khách hàng của Khách hàng hoặc dùng các Dịch vụ mà IOTLink cung cấp để xây dựng các sản phẩm cạnh tranh với IOTLink.</div>
                </>
        },
        {
            id: 5, title: 'Giá dịch vụ',
            text:
                <>
                    <div>Các thông tin về giá Dịch vụ mà IOTLink áp dụng được quy định cụ thể tại <a href="https://iotlink.com.vn/">iotlink.com.vn.</a> hoặc Hợp đồng đã ký với Khách hàng. </div>

                    <div>Tổng chi phí Dịch vụ hàng tháng Khách hàng sử dụng được tính theo biểu giá lũy tiến từng phần và được dựa trên dung lượng thực tế sử dụng của Khách hàng trong tháng đó. </div>

                    <div>Thay đổi giá Dịch vụ: Trong quá trình thực hiện Hợp đồng, giá Dịch vụ có thể được thay đổi. Trong trường hợp này, chậm nhất là 15 (mười lăm) ngày trước ngày chính thức điều chỉnh giá, IOTLink sẽ
                        có thông báo cho Khách hàng về mức giá và thời điểm áp dụng giá Dịch vụ mới. Giá dịch vụ sẽ được cập nhật tại website <a href="https://iotlink.com.vn/">iotlink.com.vn.</a> </div>
                </>
        },
        {
            id: 6, title: 'Đối soát và thanh toán ',
            text:
                <>
                    <div><b>Mốc thời gian tính đối soát:</b> Hàng tháng, hai bên tiến hành đối soát sản lượng dịch vụ. Thời gian lấy số liệu đối soát tính từ 0 giờ 00 phút ngày 01 đến hết 23 giờ 59 phút ngày cuối cùng của tháng đối soát (tháng N). Số liệu đối soát được lấy từ hệ thống Báo cáo của IOTLink. </div>

                    <div><b>Gửi Biên bản đối soát:</b> Trước ngày 05 của tháng N+1, IOTLink sẽ gửi Biên bản đối soát số lượng ký tự thực tế mà Khách hàng sử dụng của tháng trước đó qua Thư điện tử (email).  </div>

                    <div><b>Xác nhận đối soát:</b> Trong vòng 03 (ba) ngày làm việc tiếp theo, Khách hàng có trách nhiệm xác nhận qua email Biên bản đối soát mà IOTLink gửi. Nếu hết hạn 03 (ba) ngày làm việc mà IOTLink chưa nhận được phản hồi xác nhận của Khách hàng thì sẽ lấy số liệu của IOTLink để làm căn cứ thanh toán phí Dịch vụ. </div>

                    <div><b>Hồ sơ thanh toán:</b> IOTLink sẽ gửi hồ sơ thanh toán cho Khách hàng gồm: </div>

                    <div><div className="indentation"> - Hóa đơn do IOTLink phát hành (khi Khách hàng yêu cầu).</div></div>
                    <div><div className="indentation"> - Biên bản đối soát qua email.</div></div>

                    <div><b>Thanh toán phí dịch vụ:</b> <br /></div>

                    <div><b>Thời hạn thanh toán:</b> Khách hàng có trách nhiệm thanh toán 100% phí Dịch vụ của tháng đối soát cho IOTLink trong vòng 07 (bảy) ngày kể từ ngày hai bên xác nhận Biên bản đối soát. </div>

                    <div><b>Phương thức thanh toán: </b>có 2 cách thanh toán: </div>

                    <div>Khách hàng thanh toán chuyển khoản vào tài khoản của IOTLink như sau: </div>
                    <div><div className="indentation"> - Chủ tài khoản: CÔNG TY TNHH IOTLINK</div></div>
                    <div><div className="indentation"> - Tài khoản số: 0251002751257</div></div>
                    <div><div className="indentation"> - Mở tại: Ngân hàng TMCP Ngoại thương Việt Nam - CN Bình Tây</div></div>

                    <div>Khách hàng thanh toán trực tuyến qua hệ thống mà IOTLink đang sử dụng. </div>

                    <div><b>Lãi trả chậm: </b>[0,05% x (số ngày trả chậm) x (số tiền trả chậm)]. Lãi trả chậm của tháng trước sẽ được cộng dồn vào Biên bản đối soát tháng sau. Nếu 03 tháng liên tiếp Khách hàng vi phạm về thời hạn thanh toán thì IOTLink có quyền thông báo ngưng kết nối, đơn phương chấm dứt hợp đồng và yêu cầu bồi thường thiệt hại. </div>

                    <div>Khách hàng có trách nhiệm thanh toán cho IOTLink phí dịch vụ của tháng N chậm nhất là ngày cuối cùng của tháng N+1. Từ 0 giờ 00 phút ngày đầu tiên của tháng N+2, hệ thống sẽ tự động tạm ngưng cung cấp dịch vụ cho Khách hàng. </div>
                </>
        },
        {
            id: 7, title: 'Miễn trách nhiệm',
            text:
                <>
                    <div>IOTLink được miễn trừ mọi trách nhiệm liên quan đến các nội dung do Khách hàng cung cấp, trừ trường hợp IOTLink tự ý chỉnh sửa đối với các nội dung đó mà không được sự đồng ý bằng văn bản của Khách hàng. Trong trường hợp xảy ra các vấn đề nhạy cảm liên quan đến chính trị và thuần phong mỹ tục, hoặc tranh chấp, khiếu nại, khiếu kiện liên quan tới nội dung Khách hàng cung cấp, Khách hàng sẽ là bên hoàn toàn chịu trách nhiệm xử lý và giải quyết hậu quả. </div>

                    <div>IOTLink không phải chịu trách nhiệm đối với Khách hàng hoặc bất kỳ đối tác nào của Khách hàng đối với bất kỳ chi phí, khoản tiền phải trả, sự mất mát hoặc thiệt hại nào phát sinh mà không do lỗi của IOTLink trong việc không hoàn thành, không thực hiện chính xác, lỗi, sự thiếu sót, nhầm lẫn hoặc chậm trễ của Dịch vụ cung cấp.  </div>

                    <div>IOTLink không phải chịu trách nhiệm với Khách hàng hoặc bất kỳ đối tác nào của Khách hàng trong trường hợp IOTLink không thể thực hiện các nghĩa vụ theo Hợp đồng này hoặc không thể cung cấp Dịch vụ trong trường hợp xảy ra các sự kiện bất khả kháng bao gồm nhưng không giới hạn bởi thiên tai, dịch bệnh, các điều kiện thời tiết, bãi công, do việc vi phạm hoặc không thực hiện của đối tác Khách hàng, do sự cố thiết bị của Khách hàng hoặc do những khó khăn, cản trở trong việc truyền phát hoặc phải tuân theo quy định của cơ quan có thẩm quyền hoặc gián đoạn cung cấp Dịch vụ. </div>
                </>
        },

    ]
    return (
        <div className='detailedTerms'>
            {
                data.map((value, index) => {
                    return (
                        <React.Fragment key={value.id}>
                            <div className='titContent'>{value.title}</div>
                            <div className="text">
                                {value.text}
                            </div>
                        </React.Fragment>
                    )
                })
            }
        </div>
    );
};

DetailedTerms.propTypes = {
};

export default DetailedTerms;
